<div>
    <mat-select *ngIf="timeFilter" app-small-select placeholder="{{'Time range'|i18n}}"
                [(ngModel)]="timeFilter"
                (selectionChange)="onSelectTimeFilter($event)">
        <mat-select-trigger class="txt-p-16-4">
            {{timeFilter.type === TimeFilterType.CUSTOM && customName ? customName : (getName(timeFilter.type)|i18n)}}
        </mat-select-trigger>
        <mat-option *ngFor="let filter of timeFilters"
                    [value]="filter"
                    (click)="onClickTimeFilter(filter)"
                    [disabled]="!!disabledTypes && disabledTypes.includes(filter.type)"
                    class="txt-p-16-4">
            {{filter.type === TimeFilterType.CUSTOM && customName ? customName : (getName(filter.type)|i18n)}}
        </mat-option>
    </mat-select>
</div>

<ng-template #customRange>
    <div fxLayoutAlign="center" class="txt-s-18-4">{{'Set date and time range'|i18n}}</div>
    <form [formGroup]="customTimeRangeForm" class="mt-20" fxLayout="column">
        <div fxLayout="column" class="time-filter-container" fxLayoutGap="20px">
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="txt-p-16-4">
                <div fxFlex="20" class="txt-p-16-4">{{'Start date and time:'|i18n}}</div>
                <div app-input-container fxFlex="25" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                    <input app-input [matDatepicker]="startDate"
                           [min]="startMinDate"
                           [max]="startMaxDate"
                           formControlName="startDate">
                    <mat-datepicker-toggle [for]="startDate"></mat-datepicker-toggle>
                    <mat-datepicker #startDate></mat-datepicker>
                </div>
                <div app-input-container fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxFlex="20"
                     class="txt-p-16-4">
                    <input app-input type="number"
                           [min]="minHour"
                           [max]="startMaxHour"
                           formControlName="startHour">
                    <div>:00</div>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="txt-p-16-4">
                <div fxFlex="20" class="txt-p-16-4">{{'End date and time:'|i18n}}</div>
                <div app-input-container fxFlex="25" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
                    <input app-input [matDatepicker]="endDate"
                           [min]="endMinDate"
                           [max]="endMaxDate"
                           formControlName="endDate">
                    <mat-datepicker-toggle [for]="endDate"></mat-datepicker-toggle>
                    <mat-datepicker #endDate></mat-datepicker>
                </div>
                <div app-input-container fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxFlex="20"
                     class="txt-p-16-4">
                    <input app-input type="number"
                           [min]="minHour"
                           [max]="endMaxHour"
                           formControlName="endHour">
                    <div>:00</div>
                </div>
            </div>
            <div fxLayout="column" fxLayoutGap="10px">
                <div *ngIf="customTimeRangeForm.hasError('fromdateAfterTodate')"
                     fxLayout="row" fxLayoutAlign="center" app-error>
                    <div>{{'End date must follow start date'|i18n}}</div>
                </div>
                <div *ngIf="customTimeRangeForm.hasError('startHourOutOfRange')"
                     fxLayout="row" fxLayoutAlign="center" app-error>
                    <div>{{'Start hour out of range'|i18n}}</div>
                </div>
                <div *ngIf="customTimeRangeForm.hasError('endHourOutOfRange')"
                     fxLayout="row" fxLayoutAlign="center" app-error>
                    <div>{{'End hour out of range'|i18n}}</div>
                </div>
            </div>
        </div>
        <div fxFlexAlign="center" fxFlex="30" class="mt-30">
            <button app-primary-button
                    [disabled]="!customTimeRangeForm.valid"
                    (click)="onSubmitCustomRange()">
                {{'Apply'|i18n}}
            </button>
        </div>
    </form>
</ng-template>
